import classNames from "classnames"
import { renderRichText } from "gatsby-source-storyblok"
import React, { ComponentProps, useState } from "react"

import AccordionPlusIcon from "./Icons/AccordionPlusIcon"
import Typography from "./Typography"
import AccordionArrowIcon from "../../../../src/components/elements/V2/Icons/AccordionArrowIcon"
import { Color } from "../../../constants/V2/color"

import { getTextColorClass } from "@utils/V2/color"

type Props = {
  title: string
  body?: string | Storyblok.StoryblokRichtextContent
  textColor: Color
  iconColor: Color
  icon?: "arrow" | "plus"
  titleFontWeight?: ComponentProps<typeof Typography>["weight"]
  contentLeftPadding?: boolean
  contentTopPadding?: boolean
  children?: React.ReactNode
  openByDefault?: boolean
  closeOn?: "title" | "any"
}

const Accordion = ({
  title,
  textColor,
  body,
  iconColor,
  icon = "plus",
  titleFontWeight = "medium",
  contentLeftPadding = false,
  contentTopPadding = true,
  children,
  openByDefault = false,
  closeOn = "any",
}: Props) => {
  const [isOpen, setIsOpen] = useState(openByDefault)

  const onClick = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation()
    setIsOpen(!isOpen)
  }

  return (
    <div className="grid cursor-pointer grid-cols-[1fr_max-content] items-start gap-x-16">
      <button className="text-left" onClick={onClick}>
        <Typography
          font="grotesk"
          color={textColor}
          text={title}
          size="body-lg"
          weight={titleFontWeight}
        />
      </button>

      <button onClick={closeOn === "any" ? onClick : undefined}>
        {icon === "plus" ? (
          <AccordionPlusIcon color={iconColor} open={isOpen} />
        ) : (
          <AccordionArrowIcon open={isOpen} color={iconColor} />
        )}
      </button>
      <div
        className={classNames(
          "col-span-2 max-h-0 flex-nowrap overflow-hidden transition-height duration-200 ease-in-out",
          { "max-h-0": !isOpen },
          { "max-h-full": isOpen },
          { "pl-10 sm:pl-20": contentLeftPadding },
          { "pt-16": contentTopPadding }
        )}
      >
        {typeof body !== "string" ? (
          <div
            className={classNames(
              getTextColorClass(textColor),
              "text-responsive-body-md font-grotesk font-normal",
              "space-y-20 [&_a]:text-blue"
            )}
            dangerouslySetInnerHTML={{ __html: renderRichText(body) }}
          />
        ) : (
          <Typography
            text={body}
            font="grotesk"
            size="body-md"
            weight="book"
            color={textColor}
          />
        )}
        {children}
      </div>
    </div>
  )
}

export default Accordion
